"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVirtualParent = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "setVirtualParent", { enumerable: true, get: function () { return dom_utilities_1.setVirtualParent; } });
//# sourceMappingURL=setVirtualParent.js.map